// extracted by mini-css-extract-plugin
export default {"menu":"MenuMini_menu__srsh4","section":"MenuMini_section__WOg+V","page":"MenuMini_page__QmHDL","item":"MenuMini_item__9zTV1"};